var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeafLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.154,
    height: 33.792,
    viewBox: "0 0 11.154 33.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M0-1711.208H11.154V-1745H0Z",
    transform: "translate(0 1745)",
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_402",
    "data-name": "Rectangle 402",
    width: 11.178,
    height: 34.059,
    fill: "#151b47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M3.607-1714.113c1.255.667,2.6.655,3.228-.754a22.966,22.966,0,0,0,1.529,1.981,2.171,2.171,0,0,0-2.96,1.372c1.355.53,2.714.365,3.175-1.121.437.492.9.967,1.384,1.426h.386c-.547-.506-1.068-1.031-1.556-1.58,1.6-.218,1.913-1.457,1.911-2.562-1.092.234-2.439.842-2.163,2.279a22.616,22.616,0,0,1-1.486-1.92c1.592-.034,2.047-1.217,2.176-2.306-1.091.106-2.471.558-2.382,1.991a22.565,22.565,0,0,1-1.216-2.058c1.547.137,2.129-.973,2.383-2.029-1.079-.016-2.476.278-2.556,1.7a22.4,22.4,0,0,1-.956-2.182c1.494.309,2.193-.719,2.564-1.736-1.045-.135-2.436,0-2.686,1.385a22.332,22.332,0,0,1-.674-2.266c1.412.464,2.212-.47,2.692-1.437-1-.25-2.374-.265-2.778,1.076a22.039,22.039,0,0,1-.393-2.338c1.321.616,2.209-.221,2.79-1.129-.942-.357-2.266-.519-2.824.755a21.974,21.974,0,0,1-.1-2.367c1.2.747,2.166.015,2.841-.823-.872-.458-2.142-.761-2.838.446a21.882,21.882,0,0,1,.2-2.387c1.075.875,2.1.252,2.865-.514-.784-.549-1.974-.981-2.8.132a21.8,21.8,0,0,1,.507-2.361c.926.978,2,.467,2.845-.218-.687-.632-1.788-1.187-2.744-.159a22.374,22.374,0,0,1,.827-2.33c.763,1.075,1.879.678,2.8.077a1.732,1.732,0,0,0-2.634-.45,22.97,22.97,0,0,1,1.143-2.25c.587,1.145,1.728.862,2.716.351a1.638,1.638,0,0,0-2.508-.712,24.123,24.123,0,0,1,1.48-2.167c.393,1.209,1.555,1.039,2.605.621a1.535,1.535,0,0,0-2.327-.97c.13-.164.257-.329.393-.491A4.238,4.238,0,0,0,11.154-1745c-1.249.235-2.878,1.21-2.935,2.766-.126.152-.245.306-.366.459.351-1.341-.6-1.849-1.641-1.836-.32,1.25-.015,2.29,1.368,2.178a24.007,24.007,0,0,0-1.491,2.191c.142-1.352-.893-1.759-1.939-1.643-.125,1.263.348,2.255,1.729,2a23.219,23.219,0,0,0-1.165,2.285c-.058-1.347-1.165-1.643-2.205-1.422.065,1.257.689,2.185,2.05,1.792a22.322,22.322,0,0,0-.835,2.364c-.246-1.335-1.417-1.514-2.442-1.186.245,1.235,1.008,2.085,2.333,1.552a22.3,22.3,0,0,0-.515,2.4c-.43-1.295-1.645-1.348-2.64-.914.419,1.2,1.312,1.959,2.588,1.282a22.16,22.16,0,0,0-.208,2.424c-.6-1.242-1.849-1.164-2.8-.623.58,1.148,1.586,1.8,2.8.988a21.833,21.833,0,0,0,.1,2.421A1.931,1.931,0,0,0,0-1725.837c.736,1.08,1.839,1.619,2.969.671a22.211,22.211,0,0,0,.4,2.38,2,2,0,0,0-3.019.008c.882,1,2.069,1.412,3.1.333a22.567,22.567,0,0,0,.69,2.326,2.054,2.054,0,0,0-3.068.339c1.015.9,2.27,1.18,3.185-.017a22.666,22.666,0,0,0,.983,2.239,2.1,2.1,0,0,0-3.08.677c1.141.79,2.449.928,3.23-.381a22.841,22.841,0,0,0,1.253,2.12,2.142,2.142,0,0,0-3.036,1.029",
    transform: "translate(0 1745)",
    fill: "#151b47",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(0 -0.011)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(0 0.011)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M-1-1746H10.193v34.056H-1Z",
    transform: "translate(0.981 1745.981)",
    fill: "#151b47"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafLeft);
export default __webpack_public_path__ + "static/media/leafLeft.e18eb7ca9596b01f91737b3931de4bba.svg";
export { ForwardRef as ReactComponent };